export default "__VITE_ASSET__cbb980e8__"